module.exports = __webpack_public_path__ + "img/design_soundspot.ed84fdd7.jpg";